// import one from '../assets/jpg/landingPage.jpg'
// import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'THOROUGHLY COVERED',
        projectDesc: 'Thoroughly Covered is your one-stop solution for all your insurance plans.',
        tags: ['HTML5', 'CSS3', 'JavaScript', 'Bootstrap 5'],
        code: 'https://thoroughlycovered.com/',
        demo: 'https://thoroughlycovered.com/',
        image: 'https://i.ibb.co/J32NP66/thoroughly-Covered.png'
    },
    // {
    //     id: 1,
    //     projectName: 'Apna E Mart',
    //     projectDesc: 'A E-Commerce full-stack website with MERN stack technologies.',
    //     tags: ['HTML5', 'CSS3', 'JavaScript', 'NodeJS', 'ReactJS & Redux', 'Mongoose & MongoDB', 'Matrial UI', 'API'],
    //     code: 'https://github.com/alokkumar-dev/apna-e-mart',
    //     demo: 'https://apna-e-mart.vercel.app/',
    //     image: 'https://i.ibb.co/sCQWLzB/apna-e-mart.jpg'
    // },
    {
        id: 2,
        projectName: 'Printertales',
        projectDesc: 'At Printer Tales, our goal is to provide you with quick and working solutions',
        tags: ['HTML5', 'CSS3', 'JavaScript', 'NodeJS', 'ReactJS & Redux', 'MongoDB','Express JS', 'Matrial UI', 'API'],
        code: 'https://github.com/alokkumar-dev/printertales',
        demo: 'https://printertales.vercel.app/',
        image: 'https://i.ibb.co/9GSzPH8/printertales.png'
    },
    {
        id: 3,
        projectName: 'UNIQLO CLONE',
        projectDesc: 'It is a web application for users to purchase clothes for Men , Women , Baby and Kids.',
        tags: ['HTML5', 'CSS3', 'JavaScript', "LocalStorge"],
        code: 'https://github.com/Shreyasgkhakal100/uniqlo-clone-masai-unit-3-project',
        demo: 'https://uniqlo-clone.netlify.app/',
        image: 'https://i.ibb.co/7yz8KCY/home1.jpg'
    },
    {
        id: 4,
        projectName: 'HOKMAKEUP CLONE',
        projectDesc: 'HOK makeup is a website for buying makeup toolkits and accessories from the brands across the whole world.',
        tags: ['HTML5', 'CSS3', 'JavaScript', "LocalStorage"],
        code: 'https://github.com/h1t3ndr4/HOKMAKEUP-SITE',
        demo: 'https://hokmakeup-clone.vercel.app/',
        image: "https://i.ibb.co/55R2jzV/landing-Page.jpg"
    },
     {
        id: 5,
        projectName: 'BookMyShow Clone',
        projectDesc: 'The Book my show a website for book Movie Theater Tickets according to your Cities',
        tags: ['HTML', 'CSS', 'JavaScript', 'React', 'Redux', 'Express', 'MongoDB'],
        code: 'https://github.com/alokkumar-dev/bookmyshow-clone',
        demo: 'https://bookmyshow-clone-eight.vercel.app/',
        image: 'https://i.ibb.co/pvCPGN0/landing-page.jpg'
    },
    {
        id: 6,
        projectName: 'LinkedIn UI React',
        projectDesc: 'This repository contains a simple linkedIn clone that is designed using React for practicing purpose.',
        tags: ['ReactJS', 'HTML5', 'CSS3'],
        code: 'https://github.com/alokkumar-dev/linkedIn-ui-react',
        demo: 'https://linked-in-ui-react.vercel.app/',
        image: 'https://i.ibb.co/HzWcgVS/linked-In-ui-react.jpg'
    },
    {
        id: 7,
        projectName: 'Weather App',
        projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
        tags: ['Openweather API', 'JavaScript', 'HTML5', 'CSS3', "LocalStorage"],
        code: 'https://github.com/alokkumar-dev/weather-app',
        demo: 'https://weather-app-phi-liart.vercel.app/',
        image: 'https://i.ibb.co/sPfzspC/Weather-App.jpg'
    },
    {
        id: 8,
        projectName: 'Toggle Task ',
        projectDesc: 'This project is created for Toggle Tack.',
        tags: ['HTML5', 'CSS3', "JavaScript", "LocalStorage"],
        code: 'https://github.com/alokkumar-dev/toggleTask',
        demo: 'https://toggle-task.vercel.app/',
        image: 'https://i.ibb.co/c2t1DwG/Toggle-Task.jpg'
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/